import React from 'react'

const SkeletonCard = () => {
  return (
    <div className="card p-6 animate-pulse">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="h-4 bg-gray-200 rounded w-24 mb-3"></div>
          <div className="h-8 bg-gray-200 rounded w-16 mb-2"></div>
        </div>
        <div className="flex-shrink-0">
          <div className="w-16 h-16 bg-gray-200 rounded-xl"></div>
        </div>
      </div>
    </div>
  )
}

export default SkeletonCard
